export function calculateIMC(peso, talla) {
  if (!peso || !talla) return null;
  const p = parseFloat(peso);
  const t = parseFloat(talla);
  if (isNaN(p) || isNaN(t) || t === 0 || p === 0) return null;
  return (p / Math.pow(t / 100, 2)).toFixed(1);
}

export function classifyIMC(imc) {
  if (!imc) return null;
  const v = parseFloat(imc);
  if (v < 18.5) return { label: "Bajo peso", color: "#F9A01B" };
  if (v < 25) return { label: "Normal", color: "#157346" };
  if (v < 30) return { label: "Sobrepeso", color: "#F9A01B" };
  return { label: "Obesidad", color: "#C0453A" };
}

export function classifyBP(sistolica, diastolica) {
  if (!sistolica || !diastolica) return null;
  const s = parseFloat(sistolica);
  const d = parseFloat(diastolica);
  if (isNaN(s) || isNaN(d)) return null;

  // Clasificar sistólica
  let categoriaSist = "normal";
  if (s > 180) categoriaSist = "crisis";
  else if (s >= 140) categoriaSist = "hta2";
  else if (s >= 130) categoriaSist = "hta1";
  else if (s >= 120) categoriaSist = "elevada";

  // Clasificar diastólica
  let categoriaDiast = "normal";
  if (d > 120) categoriaDiast = "crisis";
  else if (d >= 90) categoriaDiast = "hta2";
  else if (d >= 80) categoriaDiast = "hta1";
  // Nota: no existe "elevada" para diastólica sola

  // Orden de gravedad: crisis > hta2 > hta1 > elevada > normal
  const orden = ["normal", "elevada", "hta1", "hta2", "crisis"];
  const indiceSist = orden.indexOf(categoriaSist);
  const indiceDiast = orden.indexOf(categoriaDiast);

  // Prevalece la mayor (más grave)
  const categoriaFinal = orden[Math.max(indiceSist, indiceDiast)];

  // Mapeo a labels y colores
  const clasificaciones = {
    normal: { label: "Normal", color: "#157346", key: "normal" },
    elevada: { label: "Elevada", color: "#F9A01B", key: "elevada" },
    hta1: { label: "HTA I", color: "#F9A01B", key: "hta1" },
    hta2: { label: "HTA II", color: "#C0453A", key: "hta2" },
    crisis: { label: "⚠️ Crisis", color: "#C0453A", key: "crisis", isCrisis: true }
  };

  return clasificaciones[categoriaFinal];
}

export function classifyGlucose(glucemia) {
  if (!glucemia) return null;
  const v = parseFloat(glucemia);
  if (isNaN(v)) return null;
  if (v < 100) return { label: "Normal", color: "#157346" };
  if (v < 126) return { label: "Hiperglicemia", color: "#F9A01B" };
  return { label: "Diabetes", color: "#C0453A" };
}

export function calculateAge(fechaNacimiento) {
  if (!fechaNacimiento) return null;
  const birth = new Date(fechaNacimiento);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age >= 0 ? age : null;
}

export function isValidEmail(email) {
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function getAutoDetectedConditions(data, imc) {
  const auto = [];
  const glu = parseFloat(data.glucemia);
  const imcVal = imc ? parseFloat(imc) : null;

  const bpClass = classifyBP(data.paSistolica, data.paDiastolica);
  if (bpClass) {
    if (bpClass.key === "crisis" || bpClass.key === "hta2") auto.push("hta2");
    else if (bpClass.key === "hta1") auto.push("hta1");
    else if (bpClass.key === "elevada") auto.push("pa_elevada");
  }

  if (!isNaN(glu) && glu >= 100 && glu < 126) auto.push("hiperglicemia");
  if (!isNaN(glu) && glu >= 126) auto.push("diabetes");

  if (imcVal && imcVal >= 25 && imcVal < 30) auto.push("sobrepeso");
  if (imcVal && imcVal >= 30) auto.push("obesidad");

  return auto;
}
